<template>
  <div class="footer">
    <div class="wp">
      <div class="top">
        <div class="col_l">
          <div class="f-links" v-if="navlist">
            <!-- <dl
              class="f-dl"
              v-for="(item, index) of navlist.slice(1)"
              :key="index"
            >
              <dt>{{ item.name }}</dt>
              <dd v-if="item.sub">
                <div class="a1" v-for="(item, index) of item.sub" :key="index">
                  <router-link :to="item.url" v-if="item.show">
                    {{ item.name }}
                  </router-link>
                </div>
              </dd>
            </dl> -->
            <dl class="f-dl" v-for="(item, index) of navlist.slice(1)" :key="index">
              <template v-if="item.name !== isService">
                <dt v-if="item.show">
                  <template v-if="item.url">
                    <router-link :to="item.url">{{ item.name }}</router-link>
                  </template>
                  <template v-else>{{ item.name }}</template>
                </dt>
                <dd v-if="item.sub && item.show">
                  <div class="a1" v-for="(item, index) of item.sub" :key="index">
                    <router-link :to="item.url" v-if="item.show">
                      {{ item.name }}
                    </router-link>
                  </div>
                </dd>
              </template>
              <template v-else>
                <dt v-if="item.show">{{ item.name }}</dt>
                <dd v-if="item.sub && item.show">
                  <div class="a1" v-for="(item, index) of item.sub" :key="index">
                    <!-- <router-link :to="item.url" v-if="item.show">
                      {{ item.name }}
                    </router-link> -->
                    <a
                      v-if="item.show && item.url !== '/case'"
                      @click="toService(item.url, item.cid)"
                    >
                      {{ item.name }}
                    </a>
                    <router-link v-if="item.show && item.url == '/case'" :to="item.url">
                      {{ item.name }}
                    </router-link>
                  </div>
                </dd>
              </template>
            </dl>
          </div>
        </div>
        <!-- <div class="col_r">
          <div class="f-qr">
            <img :src="imageUrl + fqr" alt="" />
            <p>{{ $t("footer.qrtxt") }}</p>
          </div>
        </div> -->
      </div>
      <div class="bot">
        <div class="f-a1" v-if="friendLink.length > 0">
          <a
            :href="item.linkUrl"
            class="s"
            v-for="item in friendLink"
            :key="item.id"
            target="_blank"
          >
            <img :src="imageUrl + item.iconUrl" alt="" />
            {{ item.linkName }}
          </a>
        </div>
        <div class="f-copy">
          {{ siteCopyright[0] }}
          <a :href="item.split('@')[1]" v-for="(item, index) of flinks" :key="index">
            {{ item.split('@')[0] }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      friendLink: [],
      fqr: '',
      siteCopyright: [],
      flinks: [],
      isService: 'Service',

      siteInfo: {
        zhId: '1437791619985682433',
        enId: '1428188362019659778'
      }
    }
  },
  created() {
    let that = this
    /* if (that.$i18n.locale === 'zh') {
      that.isService = '服务';
      that.getFriendLink('pos-lang-cn');
      that.getInfo(that.siteInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.isService = 'Service';
      that.getFriendLink('pos-lang-en');
      that.getInfo(that.siteInfo.enId);
    } */

    that.isService = 'Service'
    that.getFriendLink('pos-lang-en')
    that.getInfo(that.siteInfo.enId)
  },
  /*  watch: {
    '$i18n.locale' (newValue) {
      let that = this;
      if (that.$i18n.locale === 'zh') {
        that.isService = '服务';
        that.getFriendLink('pos-lang-cn');
        that.getInfo(that.siteInfo.zhId);
      } else if (that.$i18n.locale === 'en') {
        that.isService = 'Service';
        that.getFriendLink('pos-lang-en');
        that.getInfo(that.siteInfo.enId);
      }
    }
  }, */
  computed: mapState(['navlist']),
  methods: {
    toService(name, id) {
      let that = this,
        serid = id
      localStorage.setItem('serId', serid)
      that.$store.commit('changeServiceId', serid)
      if (that.$route.path == '/service') {
        return
      } else {
        that.$router.push({ name: 'Service', params: { id: serid } })
      }
    },
    // 获取友情链接
    getFriendLink(lang) {
      let that = this
      let data = {
        langKey: lang
      }
      that.$http.getFriendLink(data).then(res => {
        if (res.code == 200) {
          that.friendLink = res.result.records
        }
      })
    },
    // 获取站点二维码 copyright信息
    getInfo(id) {
      let that = this
      let data = {
        id: id
      }
      that.$http.getInfo(data).then(res => {
        if (res.code == 200) {
          that.fqr = res.result.siteLogo.split(',')[1]
          that.siteCopyright = res.result.siteCopyright.split('\n')
          that.flinks = res.result.siteCopyright.split('\n').slice(1)
        }
      })
    }
  }
}
</script>

<style></style>
